import styled from 'styled-components';

const Page = styled.div`
  min-height: calc(100vh - 160px);
`;

export default Page;
